import React, {Suspense} from 'react';
import PropTypes from 'prop-types';

import {defaultOptions} from '../lib/locale';
import {useTime} from '../hooks';

import './Clock.css';

const FormattedDate = React.lazy(() => import(/* webpackChunkName: 'formatted-date' */ './FormattedDate.jsx'));

const Clock = ({ timezone, locale }) => {
  const time = useTime(1000);

  return (
    <div className="Clock">
      <Suspense fallback={<div></div>}>
        <FormattedDate time={time} locale={locale} timezone={timezone} />
      </Suspense>
    </div>
  );
};

Clock.defaultProps = {
  timezone: defaultOptions().timezone,
  locale: navigator.language
};

Clock.propTypes = {
  timezone: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired
};

export default Clock;
